import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getImmobilizationSelector } from '../selectors'
import { setAddToTimeLine } from '../store/immobilization.actions'
import { ImmobilizationConstants } from '../store/immobilization.constants'
import { IImmobilizationState } from '../store/immobilization.types'
import { addImmobilizationItem } from '../../../timeline/store/timeline.actions'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { handleNemsisCodeError, getUpdatedProcedureStateWithNemsisCode } from '../../../../utilities/nemsisCode.util'

export function* saveImmobilization() {
  let immobilizationState: IImmobilizationState = yield select(getImmobilizationSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  if (!pcrID) {
    // todo: add to audit log
    return
  }

  try {
    // When mutliple actions(devicesUsed) are selected, "null" is used to match the behavior of the WEB implementation.
    // If only one action is selected, its name is set as the value.
    immobilizationState = getUpdatedProcedureStateWithNemsisCode({
      procedureState: immobilizationState,
      actionField: (s) => (s.devicesUsed?.length >= 1 ? s.devicesUsed[0].name : null),
      filter1Field: null,
      filter2Field: null,
      filter3Field: null,
      nemsisCodeOptions,
    })
  } catch (error: unknown) {
    immobilizationState = handleNemsisCodeError(error, immobilizationState)
  }

  try {
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    if (pcrDoc.patient?.immobilizationStateList && pcrDoc.patient?.immobilizationStateList.length) {
      const index = pcrDoc.patient?.immobilizationStateList?.findIndex(
        (immobilization) => immobilization.key === immobilizationState.key
      )
      if (index !== -1) {
        pcrDoc.patient.immobilizationStateList[index] = immobilizationState
      } else {
        pcrDoc.patient?.immobilizationStateList.push(immobilizationState)
      }
    } else {
      pcrDoc.patient = { ...pcrDoc.patient, immobilizationStateList: [immobilizationState] }
    }
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(addImmobilizationItem())
  } catch (e) {
    yield put(throwPcrException(`saveImmobilization() error: ${e}`))
  }
}

export function* saveImmobilizationSaga() {
  yield takeLatest(
    [
      ImmobilizationConstants.SAVE_IMMOBILIZATION,
      ImmobilizationConstants.SET_DATE,
      ImmobilizationConstants.SET_TIME,
      ImmobilizationConstants.SET_DATE_TIME,
      ImmobilizationConstants.SET_ASSESSED_BY,
      ImmobilizationConstants.SET_RESPONSE,
      ImmobilizationConstants.SET_RESPONSE_PNNV,
      ImmobilizationConstants.SET_PROCEDURE_COMPLICATIONS,
      ImmobilizationConstants.SET_AUTHORIZATION,
      ImmobilizationConstants.SET_ASSESSMENT,
      ImmobilizationConstants.SET_SITE,
      ImmobilizationConstants.SET_DEVICES_USED,
      ImmobilizationConstants.SET_ATTEMPTS,
      ImmobilizationConstants.SET_ROLE_PERFORMING,
      ImmobilizationConstants.SET_ROLE_PERFORMING_PNNV,
      ImmobilizationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
      ImmobilizationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
      ImmobilizationConstants.SET_OPTION,
      ImmobilizationConstants.SET_PTA,
    ],
    performWithMutexHOG,
    saveImmobilization
  )
}
